<div class="business-plan-dashboard">
    <div class="row g-3 mb-4">
        <div class="col-12 col-lg-4">
            <div class="card dashboard-card h-100">
                <div class="card-body">
                    <h5 class="card-title">Open Rocks</h5>
                    <p class="text-muted small mb-3">Matches Leadership Team L10 meeting rocks (non-archived)</p>
                    @if (isLoadingRocks()) {
                        <div class="text-muted">Loading rocks...</div>
                    } @else {
                        <div class="rocks-stats row g-2">
                            <div class="col-6">
                                <div class="stat-label">Total Open</div>
                                <div class="stat-value">{{ rockStats().total }}</div>
                            </div>
                            <div class="col-6">
                                <div class="stat-label">% Done</div>
                                <div class="stat-value">{{ rockStats().percentDone }}%</div>
                            </div>
                            <div class="col-4">
                                <div class="stat-label">Done</div>
                                <div>{{ rockStats().done }}</div>
                            </div>
                            <div class="col-4">
                                <div class="stat-label">On Track</div>
                                <div>{{ rockStats().onTrack }}</div>
                            </div>
                            <div class="col-4">
                                <div class="stat-label">Off Track</div>
                                <div>{{ rockStats().offTrack }}</div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>

    @if (isLoadingDashboard()) {
        <div class="text-muted mb-4">Loading quarterly measurables...</div>
    } @else if (dashboardLoadFailed()) {
        <div class="text-muted mb-4">Quarterly measurables dashboard is unavailable.</div>
    } @else if (dashboard()?.measurables?.length) {
        <div class="card mb-4">
            <div class="card-body">
                <h5 class="card-title">Quarterly Measurables</h5>
                <p class="text-muted small mb-3">Current quarter highlighted; prior quarters show results only (goals are not repeated).</p>
                <div class="table-responsive">
                    <table class="table table-sm table-bordered measurables-table mb-0">
                        <thead>
                            <tr>
                                <th>Measurable</th>
                                <th>Goal</th>
                                @for (quarter of dashboard()!.quarters; track quarter.key) {
                                    <th [class.current-quarter-col]="quarter.isCurrent">
                                        {{ quarter.name }}
                                        @if (quarter.isCurrent) {
                                            <span class="badge bg-primary ms-1">Current</span>
                                        }
                                    </th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            @for (row of dashboard()!.measurables; track row.id) {
                                <tr>
                                    <td>{{ row.name }}</td>
                                    <td>{{ row.goalLabel }}</td>
                                    @for (quarter of dashboard()!.quarters; track quarter.key) {
                                        <td
                                            [title]="formatExact(getQuarterValue(row, quarter.key))"
                                            [ngClass]="{
                                                'current-quarter-col': quarter.isCurrent,
                                                'green-cell': getCellClass(row, getQuarterValue(row, quarter.key)) === 'green-cell',
                                                'red-cell': getCellClass(row, getQuarterValue(row, quarter.key)) === 'red-cell',
                                            }"
                                        >
                                            {{ formatValue(row, getQuarterValue(row, quarter.key)) }}
                                        </td>
                                    }
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    }
</div>
